import { gql } from '@apollo/client';
import { BUDGET_ITEM_WITH_CATEGORY } from '../../queries/budget/budgetItems';

// Crear nueva partida presupuestaria (solo ADMIN)
export const CREATE_BUDGET_ITEM = gql`
  mutation CreateBudgetItem($input: CreateBudgetItemInput!) {
    createBudgetItem(input: $input) {
      ...BudgetItemWithCategory
    }
  }
  ${BUDGET_ITEM_WITH_CATEGORY}
`;

// Actualizar partida presupuestaria (solo ADMIN)
export const UPDATE_BUDGET_ITEM = gql`
  mutation UpdateBudgetItem($id: ID!, $input: UpdateBudgetItemInput!) {
    updateBudgetItem(id: $id, input: $input) {
      ...BudgetItemWithCategory
    }
  }
  ${BUDGET_ITEM_WITH_CATEGORY}
`;

// Eliminar (desactivar) partida presupuestaria (solo ADMIN)
export const DELETE_BUDGET_ITEM = gql`
  mutation DeleteBudgetItem($id: ID!) {
    deleteBudgetItem(id: $id) {
      ...BudgetItemWithCategory
    }
  }
  ${BUDGET_ITEM_WITH_CATEGORY}
`;

// Reactivar partida presupuestaria (solo ADMIN)
export const ACTIVATE_BUDGET_ITEM = gql`
  mutation ActivateBudgetItem($id: ID!) {
    activateBudgetItem(id: $id) {
      ...BudgetItemWithCategory
    }
  }
  ${BUDGET_ITEM_WITH_CATEGORY}
`;

